export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-950"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20media%20entertainment%20studio%20scene%20with%20warm%20amber%20accent%20lighting%2C%20mysterious%20atmosphere%2C%20professional%20video%20production%20equipment%20silhouettes%2C%20dramatic%20spotlight%20effect%2C%20luxurious%20dark%20theater%20interior%2C%20velvet%20curtains%2C%20golden%20and%20crimson%20color%20palette%2C%20cinematic%20composition%2C%20high%20contrast%2C%20film%20noir%20aesthetic%2C%20editorial%20photography%2C%20professional%20lighting%20setup%2C%20rich%20textures&width=1600&height=900&seq=hero-bg-main-2026&orientation=landscape"
          alt="黑料视频 - 娱乐资讯视频平台"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/75"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="flex-1 w-full lg:w-auto text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-accent-500/20 border border-accent-500/30 rounded-full px-4 py-1.5 mb-5">
              <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
              <span className="text-xs font-medium text-accent-300 whitespace-nowrap">每日更新 · 海量资源</span>
            </div>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 leading-tight mb-4">
              黑料视频
              <span className="block text-primary-400 text-lg md:text-2xl lg:text-3xl mt-2 font-body font-medium">
                全网热门黑料视频聚合平台
              </span>
            </h1>

            <p className="text-sm md:text-base text-background-300 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              黑料视频汇聚最新娱乐资讯与话题热点，提供黑料视频在线观看与黑料视频下载一站式入口。无论是最新爆料、明星八卦还是热门事件追踪，这里都能帮你第一时间掌握。我们每日更新官网最新地址，确保用户随时畅享流畅观看体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-7">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 md:w-9 md:h-9 rounded-lg bg-primary-500/20 flex items-center justify-center">
                  <i className="ri-play-circle-line text-primary-400 text-lg"></i>
                </div>
                <div>
                  <p className="text-xs text-background-400">海量视频</p>
                  <p className="text-sm md:text-base font-semibold text-background-50">10万+ 资源</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 md:w-9 md:h-9 rounded-lg bg-accent-500/20 flex items-center justify-center">
                  <i className="ri-user-smile-line text-accent-400 text-lg"></i>
                </div>
                <div>
                  <p className="text-xs text-background-400">活跃用户</p>
                  <p className="text-sm md:text-base font-semibold text-background-50">500万+ 粉丝</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 md:w-9 md:h-9 rounded-lg bg-primary-500/20 flex items-center justify-center">
                  <i className="ri-refresh-line text-primary-400 text-lg"></i>
                </div>
                <div>
                  <p className="text-xs text-background-400">内容更新</p>
                  <p className="text-sm md:text-base font-semibold text-background-50">每日 200+</p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold px-6 py-3 rounded-full text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-fill text-lg"></i>
                立即观看
              </a>
              <a
                href="#app"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-background-50/10 hover:bg-background-50/20 text-background-50 border border-background-50/20 font-medium px-6 py-3 rounded-full text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-cloud-2-line text-lg"></i>
                下载App
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-2 bg-gradient-to-r from-primary-500/20 via-accent-500/10 to-primary-500/20 rounded-2xl blur-xl"></div>
              <div className="relative bg-background-900/80 border border-background-700/50 rounded-2xl overflow-hidden">
                <div className="aspect-video relative">
                  <img
                    src="https://readdy.ai/api/search-image?query=Cinematic%20video%20player%20interface%20with%20dark%20theme%2C%20glowing%20amber%20play%20button%20center%2C%20modern%20streaming%20platform%20UI%20design%2C%20entertainment%20news%20thumbnails%20grid%20layout%2C%20luxurious%20dark%20studio%20aesthetic%2C%20professional%20video%20production%20vibe%2C%20rich%20contrast%20lighting%2C%20premium%20media%20player%20design%2C%20editorial%20quality%2C%20high%20detail&width=800&height=450&seq=hero-visual-play-2026&orientation=landscape"
                    alt="黑料视频在线观看界面预览"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-primary-500/90 flex items-center justify-center cursor-pointer hover:bg-primary-500 transition-colors group">
                      <i className="ri-play-fill text-background-50 text-3xl md:text-4xl ml-1 group-hover:scale-110 transition-transform"></i>
                    </div>
                  </div>
                  <div className="absolute top-3 left-3 flex items-center gap-1.5">
                    <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded">HOT</span>
                    <span className="px-2 py-0.5 bg-black/60 text-background-50 text-xs rounded">12:30</span>
                  </div>
                  <div className="absolute bottom-3 right-3 px-2 py-0.5 bg-black/60 text-background-50 text-xs rounded">HD 1080P</div>
                </div>
                <div className="p-4">
                  <p className="text-sm font-medium text-background-100 mb-1">本周热门黑料 · 全网独家爆料合集</p>
                  <p className="text-xs text-background-400">播放量 328.6万 · 更新于 2 小时前</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}